import styled from 'styled-components';

export const DiscountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 25px;
`;

export const DiscountForm = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const CouponError = styled.div`
  color: #FF2323;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
`;
